import React from "react";
export default function ProfilePictureRenderer({ value }) {
  if (!value) return null;//"../img/"; // Handle missing or invalid URL
  return (
        <img
        className="img-profile rounded-circle"
        src={value}
        alt="Profile"
        style={{
          width: "32px",
          height: "32px",
          borderRadius: "50%",
          objectFit: "cover",
        }}
      />

  );
}
